class CustomizationStore {
  constructor() {
    const siteId = document.body.dataset.siteBuilderSite;
    if (siteId) {
      this.storeKey = `SiteBuilderProperties-${siteId}`;
    } else {
      this.storeKey = "SiteBuilderProperties";
    }
  }

  get values() {
    return JSON.parse(localStorage.getItem(this.storeKey) || "{}");
  }

  set values(properties) {
    localStorage.setItem(this.storeKey, JSON.stringify(properties));
  }

  dump() {
    return JSON.stringify(this.values);
  }

  clear() {
    this.values = {};
  }

  isEmpty() {
    return Object.values(this.values).every((x) => x === null);
  }

  update(payload) {
    this.values = { ...this.values, ...payload };
  }
}

export { CustomizationStore };
export default new CustomizationStore();
